import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27793fbf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "animation-index"
}

import { PropType, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { ElementTypes, PPTElement, PPTLineElement, PPTVideoElement, PPTAudioElement, PPTShapeElement } from '@/types/slides'
import { OperateLineHandlers, OperateResizeHandlers } from '@/types/edit'

import ImageElementOperate from './ImageElementOperate.vue'
import TextElementOperate from './TextElementOperate.vue'
import ShapeElementOperate from './ShapeElementOperate.vue'
import LineElementOperate from './LineElementOperate.vue'
import TableElementOperate from './TableElementOperate.vue'
import CommonElementOperate from './CommonElementOperate.vue'
import LinkHandler from './LinkHandler.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  elementInfo: {
    type: Object as PropType<PPTElement>,
    required: true,
  },
  isSelected: {
    type: Boolean,
    required: true,
  },
  isActive: {
    type: Boolean,
    required: true,
  },
  isActiveGroupElement: {
    type: Boolean,
    required: true,
  },
  isMultiSelect: {
    type: Boolean,
    required: true,
  },
  rotateElement: {
    type: Function as PropType<(element: Exclude<PPTElement, PPTLineElement | PPTVideoElement | PPTAudioElement>) => void>,
    required: true,
  },
  scaleElement: {
    type: Function as PropType<(e: MouseEvent, element: Exclude<PPTElement, PPTLineElement>, command: OperateResizeHandlers) => void>,
    required: true,
  },
  dragLineElement: {
    type: Function as PropType<(e: MouseEvent, element: PPTLineElement, command: OperateLineHandlers) => void>,
    required: true,
  },
  moveShapeKeypoint: {
    type: Function as PropType<(e: MouseEvent, element: PPTShapeElement) => void>,
    required: true,
  },
  openLinkDialog: {
    type: Function as PropType<() => void>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { canvasScale, toolbarState } = storeToRefs(useMainStore())
const { formatedAnimations } = storeToRefs(useSlidesStore())

const currentOperateComponent = computed(() => {
  const elementTypeMap = {
    [ElementTypes.IMAGE]: ImageElementOperate,
    [ElementTypes.TEXT]: TextElementOperate,
    [ElementTypes.SHAPE]: ShapeElementOperate,
    [ElementTypes.LINE]: LineElementOperate,
    [ElementTypes.TABLE]: TableElementOperate,
    [ElementTypes.CHART]: CommonElementOperate,
    [ElementTypes.LATEX]: CommonElementOperate,
    [ElementTypes.VIDEO]: CommonElementOperate,
    [ElementTypes.AUDIO]: CommonElementOperate,
  }
  return elementTypeMap[props.elementInfo.type] || null
})

const elementIndexListInAnimation = computed(() => {
  const indexList = []
  for (let i = 0; i < formatedAnimations.value.length; i++) {
    const elIds = formatedAnimations.value[i].animations.map(item => item.elId)
    if (elIds.includes(props.elementInfo.id)) indexList.push(i)
  }
  return indexList
})

const rotate = computed(() => 'rotate' in props.elementInfo ? props.elementInfo.rotate : 0)
const height = computed(() => 'height' in props.elementInfo ? props.elementInfo.height : 0)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["operate", { 'multi-select': __props.isMultiSelect && !__props.isActive }]),
    style: _normalizeStyle({
      top: __props.elementInfo.top * _unref(canvasScale) + 'px',
      left: __props.elementInfo.left * _unref(canvasScale) + 'px',
      transform: `rotate(${_unref(rotate)}deg)`,
      transformOrigin: `${__props.elementInfo.width * _unref(canvasScale) / 2}px ${_unref(height) * _unref(canvasScale) / 2}px`,
    })
  }, [
    (__props.isSelected)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentOperateComponent)), {
          key: 0,
          elementInfo: __props.elementInfo,
          handlerVisible: !__props.elementInfo.lock && (__props.isActiveGroupElement || !__props.isMultiSelect),
          rotateElement: __props.rotateElement,
          scaleElement: __props.scaleElement,
          dragLineElement: __props.dragLineElement,
          moveShapeKeypoint: __props.moveShapeKeypoint
        }, null, 8, ["elementInfo", "handlerVisible", "rotateElement", "scaleElement", "dragLineElement", "moveShapeKeypoint"]))
      : _createCommentVNode("", true),
    (_unref(toolbarState) === 'elAnimation' && _unref(elementIndexListInAnimation).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(elementIndexListInAnimation), (index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "index-item",
              key: index
            }, _toDisplayString(index + 1), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (__props.isActive && __props.elementInfo.link)
      ? (_openBlock(), _createBlock(LinkHandler, {
          key: 2,
          elementInfo: __props.elementInfo,
          link: __props.elementInfo.link,
          openLinkDialog: __props.openLinkDialog,
          onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, null, 8, ["elementInfo", "link", "openLinkDialog"]))
      : _createCommentVNode("", true)
  ], 6))
}
}

})